
		<svg width="60" height="60" version="1.1" viewBox="0 0 15.875 15.875" xmlns="http://www.w3.org/2000/svg">
			<g fill="none" stroke="#0C3121" stroke-linecap="round" stroke-linejoin="round">
				<path d="m11.962 9.0339 0.93368 1.3874m-1.8368-0.9505 0.96286 1.4842m-0.44989
				0.45976c-0.16121 0.08604 1.2719 2.0096 1.8797 2.8255 0.87823 1.2242
				2.6043 0.2573 1.9244-0.98687-0.67824-1.2411-1.8589-3.0516-1.8589-3.0516-0.75241
				0.38021-1.4815 0.92824-1.9452 1.2129zm2.3631-5.9753c0 2.3296-1.8885 4.2181-4.2181
				4.2181s-4.2181-1.8885-4.2181-4.2181c0-2.3296 1.8885-4.2181 4.2181-4.2181
				2.3296 3e-7 4.2181 1.8885 4.2181 4.2181zm-1.1596-0.012336c0 1.7232-1.397
				3.1202-3.1202 3.1202-1.7233 1e-7 -3.1202-1.397-3.1202-3.1202 0-1.7232
				1.397-3.1202 3.1202-3.1202 1.7233 3e-7 3.1202 1.397 3.1202 3.1202z" stroke-width=".529"/>
				<g>
					<g stroke-width=".52917">
						<path d="m0.37418 13.297h11.576"/>
						<path d="m0.88906 14.584h10.57"/>
						<path d="m2.3854 13.134v-3.0753c0-1.4499-1.3447-1.3798-1.3447-1.3798s-0.18709
						1.7189 1.2395 1.754c1.4266 0.03508 1.7773-1.8592 1.5435-1.8007-0.23386 0.058465-1.4499 0.38587-1.4499 1.8007"/>
						<path d="m6.2441 13.18v-2.0346c0-1.4499-1.2921-1.3681-1.2921-1.3681s-0.099391 1.4792
						1.2278 1.5084c1.4266 0.03142 1.5397-1.593 1.3038-1.5435-0.36248 0.076004-1.2512 0.36248-1.2512 1.7773"/>
						<path d="m9.7871 13.192v-1.3798c0-1.4499-1.0875-1.2921-1.0875-1.2921s-0.076692
						1.2127 1.0056 1.2979c1.0417 0.08203 1.3818-1.3591 1.1459-1.3096-0.36248 0.076-0.99391 0.02339-0.99391 1.4382"/>
					</g>
					<path d="m9.3541 7.7592v-2.0045c0-2.1064-1.5964-1.877-1.5964-1.877s-0.11259
					1.7617 1.4763 1.8855c1.5292 0.11917 2.0286-1.9744 1.6823-1.9025-0.53215 0.11041-1.4591 0.033974-1.4591 2.0894" stroke-width=".52917"/>
				</g>
			</g>
		</svg>
	